var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PrinterHeader',{attrs:{"img_header":_vm.header_image,"header":"ตั้งค่าไอพีปริ้นเตอร์"}}),_c('Printer_ip_config')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }